import { ProductCard } from '@petsmart-ui/sparky';

import { MiniPdpCTA, MiniPdpSource } from '../../MiniPdpDrawer';

interface ProductCardWithVariationsProps {
    __position: number;
    sku: string;
    title?: string;
    description?: string;
    href?: string;
    target?: '_self' | '_blank';
    imgSrc?: string;
    imgAlt?: string;
    brand?: string;
    priceVariant?: 'primary' | 'disabled' | 'sale';
    prices?: (string | number)[];
    isPriceRange?: boolean;
    outOfStock?: boolean;
    rating?: number;
    ratingLabel?: string;
    variations?: string;
    showQuickAdd?: boolean;
}

export function ProductCardWithVariations({
    variations,
    showQuickAdd,
    ...productProps
}: Readonly<ProductCardWithVariationsProps>) {
    return (
        <div className="product-card-with-variations">
            <ProductCard {...productProps} />
            {variations && <div className="product-card-with-variations__text">{variations}</div>}
            {showQuickAdd && <MiniPdpCTA productId={productProps.sku} source={MiniPdpSource.YMAL} />}
        </div>
    );
}
